module.exports = __webpack_public_path__ + "static/img/SSH_V.9921ec1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/oceantool/SSH_V.png
// module id = a0i3
// module chunks = 18